import React from 'react';
import { useQuery } from 'react-apollo-hooks';
import { AccountContext } from '../../../../../context/account';
import { accountMembersQuery } from '../../../../../queries/account';
import {
  AccountMembersQuery,
  AccountMembersQueryVariables
} from '../../../../../queries/__generated__/AccountMembersQuery';
import { Modal } from '../../../../ui';
import { ErrorScreen, Loading } from '../../../../utils';
import HasAvailableMembers from './HasAvailableMembers';
import NoAvailableMembers from './NoAvailableMembers';

interface AddMemberToSubjectModal {
  closeModal: () => void;
  subject: {
    id: string;
    name: string;
    slug: string;
  };
  subjectMembers: {
    id: string;
    member: {
      id: string;
    };
  }[];
}

const AddMemberToSubjectModal: React.FC<AddMemberToSubjectModal> = ({
  closeModal,
  subject,
  subjectMembers
}) => {
  const accountContext = React.useContext(AccountContext);

  const { data, loading, error } = useQuery<AccountMembersQuery, AccountMembersQueryVariables>(
    accountMembersQuery,
    { variables: { input: { accountId: accountContext.selectedAccountId } } }
  );
  if (loading) return <Loading />;
  if (error) return <ErrorScreen error={error.message} />;

  const subjectMemberIds = subjectMembers.map(({ member }) => member.id);
  const accountMembers = data!.accountMembers;
  const filteredAccountMembers = accountMembers
    .filter(member => member.membershipStatus !== 'INACTIVE')
    .filter(member => !subjectMemberIds.includes(member.id));

  return (
    <Modal closeModal={closeModal}>
      {filteredAccountMembers.length === 0 ? (
        <NoAvailableMembers />
      ) : (
        <HasAvailableMembers
          closeModal={closeModal}
          subject={subject}
          members={filteredAccountMembers}
        />
      )}
    </Modal>
  );
};

export default AddMemberToSubjectModal;
